//@flow
import React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import { SketchPicker, AlphaPicker } from 'react-color';
import { getLayersConfig } from '../../../../../actions/map';
import { modalInstance } from '../../../../../containers/content/Content';
import MenuIcon from './../../../../../icons/menu.svg';
import { translate } from "react-i18next";
import Checkbox from '../../../../../components/checkbox/Checkbox';

import Photos from './../../../../../icons/Photo_direction_symbol.svg';
import Missions from './../../../../../icons/Missions.png';
import Videos from './../../../../../icons/Flight_path.png';
import Faults from './../../../../../icons/Fault.svg';
import Comments from './../../../../../icons/Comment.svg';
import DropdownMenu from '../../../../../components/DropdownMenu';
import { setExtent } from '../../../../../actions/map';
import { getFlights } from '../../../../../actions/flightManager';
import messageManager from '../../../../../utilities/messageManager';

const legendImage = {
    Photos: Photos,
    Missions: Missions,
    Videos: Videos,
    Faults: Faults,
    Comments: Comments,
};

const LabelWrapper = styled.div`
    display: flex;
    flex-direction: column;    
`;

const StyledLabel = styled.label`
    display: flex;
    flex-direction: row; 
    align-items: center;
    justify-content: space-between;
    margin: 5px 0;
    color:  #2d2d2d;
    font-size: 13px;
    font-weight: 600;
    >input{
        height: 20px;
        width: 20px;
    }
`;

const StyledLegend = styled.div`
    display: flex;
    align-items: flex-start;
    margin-left: 15px;
`;

const LegendImg = styled.img`
    height: 25px;
    margin-right: 5px;
`;

const DropDownListRow = styled.div`
    pointer-events: ${props => props.disabled ? 'none' : 'all'};
    background-color: ${props => props.disabled ? 'rgba(256, 256, 256, 0.5)' : 'transparent'};
`;

const LegendImgWrapper = styled.div`
    width: ${props => props.private ? 'calc(100% - 50px)' : 'calc(100% - 25px)'};
    display: flex;
    align-items: center;
    >span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

const StyledSpinner = styled.div`
	margin-left: auto;
	margin-top: 3px;
	margin-right: 3px;
	border-top: 3px solid #265a9c50;
	border-right: 3px solid #265a9c50;
	border-bottom: 3px solid #265a9c50;
	border-left: 3px solid #265a9c;
	animation: animation 1.1s infinite linear;
	border-radius: 50%;
	width: 12px;
	height: 12px;

  @keyframes animation {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
`;

export class LayerLabel extends React.Component {
    constructor() {
        super();
        this.state = {
            menuVisible: false,
            spinnerVisible: false
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    changeLayerVisibility(layer: object): void {
        const newVisible = !layer.values_.visible;
        layer.setVisible(newVisible);
        this.forceUpdate();
    }

    deleteLayer() {
        const { BASE_URL, t, layer } = this.props;
        const confirmCallback = () => {
            this.props.axiosInstance.delete(`${BASE_URL}/layers/delete-geoserver/${this.props.layer.values_.id}`)
                .then((response) => {
                    this.setState({
                        spinnerVisible: false
                    });
                    this.props.getFlights(this.props.axiosInstance);
                    this.props.getLayersConfig(this.props.axiosInstance, this.props.chosenFlight.id);
                    messageManager.show({
                        type: 'info',
                        text: t('Layer deleted'),
                    });
                })
                .catch(error => {
                    messageManager.show({
                        type: 'error',
                        text: t(error.response.data ? error.response.data : t('Error occured while deleting layer')),
                    });
                });
        }
        const cancelCallback = () => {
            this.setState({
                spinnerVisible: false
            });
        }
        const config = {
            title: t('Do you really want to delete layer and related data') + '?',
            content: <p>{t('Do you really want to delete layer and related data')} <b>{String(layer.values_.name)}</b>?</p>,
            confirmCallback: confirmCallback,
            cancelCallback: cancelCallback,
            cancelBtnVisible: true,
            confirmBtnVisible: true,
            confirmBtnText: t('Delete'),
            closeOnConfirm: true,
            type: 'warning',
        }
        modalInstance.customize(config);
        modalInstance.show();
    }

    moveUpLayer(): void {
        const { BASE_URL } = this.props;
        this.props.axiosInstance.post(`${BASE_URL}/layers/${this.props.layer.values_.id}/move-up`)
            .then((response) => {
                this.setState({
                    spinnerVisible: false
                });
                this.props.getLayersConfig(this.props.axiosInstance, this.props.chosenFlight.id);
            });
    }

    moveDownLayer(): void {
        const { BASE_URL } = this.props;
        this.props.axiosInstance.post(`${BASE_URL}/layers/${this.props.layer.values_.id}/move-down`)
            .then((response) => {
                this.setState({
                    spinnerVisible: false
                });
                this.props.getLayersConfig(this.props.axiosInstance, this.props.chosenFlight.id);
            });
    }

    downloadLayerFiles(): void {
        const { BASE_URL } = this.props;
        this.props.axiosInstance.get(`${BASE_URL}/layers/${this.props.layer.values_.id}/prepare-package`)
            .then((response) => {
                this.setState({
                    spinnerVisible: false
                });
                const token = localStorage.getItem('token');
                const fileName = `layer_${this.props.layer.values_.id}.zip`;
                const src = `${BASE_URL}/layers/download/${response.data}/${fileName}?token=${token}`;
                window.location.href = src;
            });
    }

    zoomToLayer() {
        const { BASE_URL } = this.props;
        this.props.axiosInstance.get(`${BASE_URL}/layers/${this.props.layer.values_.id}/extent`)
            .then((response) => {
                this.setState({
                    spinnerVisible: false
                });
                this.props.setExtent(response.data);
            });
    }

    hexToRgb(hex): Object {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : {
                r: 0,
                g: 0,
                b: 0
            };
    }

    changeLayerStyle(): void {
        const { BASE_URL, t, layer } = this.props;
        let layerColor = layer.values_.color;
        let layerOpacity = layer.values_.opacity;
        let rgb = this.hexToRgb(layer.values_.color);
        rgb.a = layer.values_.opacity;

        const confirmCallback = () => {
            //if (styleId) {
            modalInstance.close();
            this.props.axiosInstance.put(`${BASE_URL}/layers/${this.props.layer.values_.id}/style`, { color: layerColor, opacity: layerOpacity })
                .then((response) => {
                    this.setState({
                        spinnerVisible: false
                    });
                    this.props.getLayersConfig(this.props.axiosInstance, this.props.chosenFlight.id);
                });
            //}
        }
        const cancelCallback = () => {
            this.setState({
                spinnerVisible: false
            });
        }

        const config = {
            title: t('Change layer style'),
            content:
                <div style={{ marginBottom: '20px' }}>
                    <p>{t('Choose new style for layer')} <b>{String(layer.values_.name)}</b></p>
                    {layer.values_.type === 4 || layer.values_.type === 5 ?
                        <div>
                            <p>{t('Opacity')}</p>
                            <AlphaPicker
                                color={rgb}
                                onChangeComplete={(color) => {
                                    layerOpacity = color.rgb.a;
                                }} />
                        </div>
                        : <SketchPicker
                            color={rgb}
                            onChangeComplete={(color) => {
                                layerOpacity = color.rgb.a;
                                layerColor = color.hex;
                            }} />
                    }
                </div>,
            confirmCallback: confirmCallback,
            cancelCallback: cancelCallback,
            cancelBtnVisible: true,
            confirmBtnVisible: true,
            confirmBtnText: t('Change style'),
            closeOnConfirm: false,
            type: 'warning',
        }
        modalInstance.customize(config);
        modalInstance.show();
    }

    // source: https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClick(event) {
        if (this.props.chosenFlight === null) return;
        document.removeEventListener('mousedown', this.handleClick);
        if (this.wrapperRef && this.wrapperRef.contains(event.target)) {
            this.setState({
                spinnerVisible: true,
                menuVisible: false,
            });
            const parentId = event.target.id || event.target.parentNode.id;
            switch (parentId) {
                case 'Delete':
                    this.deleteLayer();
                    break;
                case 'MoveUp':
                    this.moveUpLayer();
                    break;
                case 'MoveDown':
                    this.moveDownLayer();
                    break;
                case 'ChangeStyle':
                    this.changeLayerStyle();
                    break;
                case 'DownloadFiles':
                    this.downloadLayerFiles();
                    break;
                case 'ZoomTo':
                    this.zoomToLayer();
                    break;
                default:
                    this.setState({
                        spinnerVisible: false
                    });
                    break;
            }
        } else {
            this.setState({
                menuVisible: false
            });
        }
    }

    render(): React.Node {
        const { layer, t, roles } = this.props;
        return (
            <LabelWrapper>
                <StyledLabel>
                    <Checkbox
                        isLightTheme={true}
                        checked={layer.values_.visible}
                        onClick={() => {
                            this.changeLayerVisibility(layer)
                        }} />
                    <LegendImgWrapper private={layer.values_.private}>
                        <LegendImg src={legendImage[layer.values_.name.replace(/\s/g, "_")] || layer.values_.legendIcon} />
                        <span title={layer.values_.name}>
                            {t(layer.values_.name)}
                        </span>
                    </LegendImgWrapper>
                    {layer.values_.private
                        ? this.state.spinnerVisible
                            ? <StyledSpinner />
                            : <div
                                style={{
                                    cursor: 'pointer',
                                    marginLeft: 'auto',
                                    marginTop: '3px',
                                    marginRight: '3px'
                                }}
                                onClick={() => {
                                    document.addEventListener('mousedown', this.handleClick);
                                    this.setState({
                                        menuVisible: !this.state.menuVisible
                                    });
                                }}>
                                <ReactSVG
                                    path={MenuIcon}
                                    style={{
                                        fill: '#215597',
                                        width: '20px',
                                        height: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                />
                            </div>
                        : null}
                    <div ref={this.setWrapperRef}
                        style={{
                            display: this.state.menuVisible ? 'flex' : 'none',
                            position: 'relative',
                        }}
                    >
                        <DropdownMenu
                            style={
                                {
                                    top: '10px',
                                    right: '28px',
                                    width: '150px',
                                    zIndex: 15,
                                }
                            }
                            menuVisible={this.state.menuVisible}
                        >
                            {roles === 'Regular' ? null : <DropDownListRow
                                id='Delete'
                                disabled={!true}
                                title={t('Delete layer')}
                            >
                                <span>{t('Delete layer')}</span>
                            </DropDownListRow>}
                            {roles === 'Regular' ? null : <DropDownListRow
                                id='MoveUp'
                                disabled={!true}
                                title={t('Move up')}
                            >
                                <span>{t('Move up')}</span>
                            </DropDownListRow>}
                            {roles === 'Regular' ? null : <DropDownListRow
                                id='MoveDown'
                                title={t('Move down')}
                            >
                                <span>{t('Move down')}</span>
                            </DropDownListRow>}
                            {roles === 'Regular' ? null : <DropDownListRow
                                id='ChangeStyle'
                                title={t('Change layer style')}
                            >
                                <span>{t('Change layer style')}</span>
                            </DropDownListRow>}
                            <DropDownListRow
                                id='DownloadFiles'
                                title={t('Download files')}
                            >
                                <span>{t('Download files')}</span>
                            </DropDownListRow>
                            <DropDownListRow
                                id='ZoomTo'
                                title={t('Zoom to layer')}
                            >
                                <span>{t('Zoom to layer')}</span>
                            </DropDownListRow>
                        </DropdownMenu>
                    </div>
                </StyledLabel>
                <StyledLegend>
                    {layer.values_.legendGraphic
                        ? <img src={layer.values_.legendGraphic} alt=""/>
                        : null}
                </StyledLegend>
            </LabelWrapper>
        );
    }
};

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    roles: state.auth.get('roles'),
    chosenFlight: state.flightManager.get('chosenFlight'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    getLayersConfig,
    setExtent,
    getFlights
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(LayerLabel));


// WEBPACK FOOTER //
// ./src/containers/content/map/popups/layerLabel/LayerLabel.jsx